import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonusValueRows, bonuses } from '../data/bonuses';
interface BonusSectionProps {
  showCountdown?: boolean;
}
export function BonusSection({
  showCountdown = true
}: BonusSectionProps) {
  return <section className="py-20 md:py-24 px-4 bg-sand-deep border-y border-copper/40" data-id="element-18" data-mp="1yejggad2aa0w">
      <div className="max-w-5xl mx-auto" data-id="element-19" data-mp="1ap8ptlpfdw0h">
        <div className="text-center mb-14" data-id="element-20" data-mp="1am2ydztbqi1l">
          <p className="text-copper font-bold tracking-widest uppercase mb-2 text-sm" data-id="element-21" data-mp="15qfarouhpwy7">
            Included at no extra cost
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-bold uppercase text-charcoal" data-id="element-22" data-mp="1jivhp0qiif4e">
            5 <span className="text-orange" data-id="element-23" data-mp="1enxzb37ceteu">Premium Bonuses</span> Free
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-24" data-mp="qyn3m04unp7k">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-copper/50 rounded-2xl p-8 relative shadow-sm flex flex-col h-full ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-25" data-mp="mws85c9lo61p" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-charcoal text-copper-light px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-26" data-mp="1vsk6fk4xi4f8">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-orange-soft rounded-full flex items-center justify-center text-orange mb-6" data-id="element-27" data-mp="25s2n9rpjla32">
                <GiftIcon size={24} aria-hidden="true" data-id="element-28" data-mp="3c8o8p8m0yl0n" />
              </div>
              <h3 className="text-xl font-display font-bold uppercase mb-2 pr-24 text-charcoal" data-id="element-29" data-mp="3h43hhm56dqq7">
                {bonus.title}
              </h3>
              <p className="text-warmgray text-sm italic mb-4" data-id="element-30" data-mp="1c4kj8m6l7il0">
                {bonus.tagline}
              </p>
              <div className="self-start bg-sand border border-copper/40 px-3 py-1 rounded mb-4" data-id="element-31" data-mp="1q4lhruzdqdxb">
                <span className="text-warmgray text-sm" data-id="element-32" data-mp="1m1yl9grrk4ts">
                  Real value:{' '}
                  <span className="line-through" data-id="element-33" data-mp="yce3h17cjdm3">${bonus.value}</span>
                </span>
                <span className="text-orange font-bold ml-2" data-id="element-34" data-mp="te2vkw0m3d6i">→ FREE</span>
              </div>
              <div className="space-y-4 mb-5 flex-grow" data-id="element-35" data-mp="1757ozgddz98e">
                {bonus.paragraphs.map(paragraph => <p key={paragraph} className="text-charcoal text-sm leading-relaxed" data-id="element-36" data-mp="12dzba850x1pf">
                    {paragraph}
                  </p>)}
              </div>
              <div className="mb-5" data-id="element-37" data-mp="amtikcrmu6a6">
                <h4 className="text-xs font-bold uppercase tracking-wider text-charcoal mb-2" data-id="element-38" data-mp="jegvwqgtrsb">
                  {bonus.listTitle}
                </h4>
                <ul className="flex flex-wrap gap-1.5" data-id="element-39" data-mp="5awhukshnsda">
                  {bonus.list.map(item => <li key={item} className="text-[11px] text-warmgray bg-mist border border-sand-deep rounded-full px-2.5 py-1" data-id="element-40" data-mp="3ms5xucc3jljs">
                      {item}
                    </li>)}
                </ul>
              </div>
              <p className="text-orange-deep text-sm font-semibold mt-auto" data-id="element-41" data-mp="o87gc36aqhro">
                {bonus.benefit}
              </p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-copper rounded-2xl p-6 md:p-8 max-w-2xl mx-auto shadow-sm" data-id="element-42" data-mp="e9hvq2n0mj7q">
          <h3 className="text-2xl font-display font-bold uppercase text-charcoal text-center mb-4" data-id="element-43" data-mp="3f9zpssv96nv8">
            Complete bonus value
          </h3>
          <p className="text-xs text-warmgray text-center mb-3 md:hidden" data-id="element-44" data-mp="35jet5az53tey">
            ← Scroll to see the full table →
          </p>
          <div className="overflow-x-auto" data-id="element-45" data-mp="30l3fsq9mz0rz">
            <table className="w-full text-sm min-w-[420px]" data-id="element-46" data-mp="226bos8bqvkr">
              <thead data-id="element-47" data-mp="1zk3qrhiue20">
                <tr className="bg-charcoal text-white" data-id="element-48" data-mp="3t87fqgtvgoww">
                  <th scope="col" className="text-left font-bold px-4 py-3 rounded-tl-lg" data-id="element-49" data-mp="3t8hb6jxoro9z">
                    Bonus
                  </th>
                  <th scope="col" className="text-right font-bold px-4 py-3 rounded-tr-lg" data-id="element-50" data-mp="3j98kq1214rsd">
                    Value
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-51" data-mp="ncu60xuat5ji">
                {bonusValueRows.map(row => <tr key={row.label} className="border-b border-sand-deep" data-id="element-52" data-mp="nahg9yiatqvw">
                    <td className="px-4 py-3 text-charcoal" data-id="element-53" data-mp="sc6qxd1m02jg">{row.label}</td>
                    <td className="px-4 py-3 text-right text-warmgray line-through" data-id="element-54" data-mp="x9p3reiqz1wq">
                      {row.value}
                    </td>
                  </tr>)}
                <tr className="bg-sand" data-id="element-55" data-mp="1712zdb7kvhkl">
                  <td className="px-4 py-3 font-bold text-charcoal" data-id="element-56" data-mp="1700at9xq9r7u">
                    TOTAL BONUS VALUE
                  </td>
                  <td className="px-4 py-3 text-right font-bold text-warmgray line-through" data-id="element-57" data-mp="1b3zir44xzhpl">
                    $64
                  </td>
                </tr>
                <tr data-id="element-58" data-mp="1kzsuilau776b">
                  <td className="px-4 py-4 font-bold text-charcoal" data-id="element-59" data-mp="1ky8avqq298n8">
                    Your price today
                  </td>
                  <td className="px-4 py-4 text-right font-bold text-orange text-lg" data-id="element-60" data-mp="3mrfp0wtxtk7j">
                    FREE
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-sm text-warmgray text-center mt-4" data-id="element-61" data-mp="3apwihybtrlkv">
            Only included in this offer. The launch pricing ends soon. After
            this, the price increases and never comes back down.
          </p>
        </motion.div>

        {showCountdown && <CountdownTimer data-id="element-62" data-mp="3js5u6ritxkzu" />}
      </div>
    </section>;
}